
import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

export default function MediaCard({name , time , imagee}) {
    return (
        <Card  style={{ marginTop: "25px" , width:"250px"} }>
            <CardMedia
                sx={{ height: 160 }}
                flexWrap={"wrap"}
                image={imagee}
                title="green iguana" 
            />
            <CardContent>
                <h2 >
                    {name}   
                </h2>
                <h1>
                    {time}
                </h1>
            </CardContent>
        </Card>
    );
}



